import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { ServerRequest } from 'http';

@Injectable()
export class AlmacenApiService {
    apiURL: string = config.API_DATA_URL + '/almacen';
    data: any[] = [];

    constructor(public http: HttpClient) { }

    public GetPendientesAlmacen(idSucursal: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetPendientesAlmacen/' + idSucursal, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetEntradaDetalle(idCotizacionDetalle: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetEntradaDetalle/' + idCotizacionDetalle, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public EntradaAlmacen(entrada: any) {
        const headers = this.getHeaders();
        const param = JSON.stringify(entrada);
        return this.http.post(this.apiURL + '/EntradaAlmacen', param, { headers })
            .map((resultado: any) => {
                return resultado;
            })
            .catch((error: any) => {
                return Observable.throw(new Error(error.status));
            });
    }

    public GetAlmacenSucursal(idSucursal: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetAlmacenSucursal/' + idSucursal, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetInventarioSucursal(idSucursal: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetInventarioSucursal/' + idSucursal, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetDetalleInventarioOrdenes(ordenes: Array<number>): Observable<any> {
        const headers = this.getHeaders();
        // let requestOptions = {
            
        //     params: new HttpParams()
        //       .append('ordenesServicio', JSON.stringify(ordenes))
        //   }
        const param = JSON.stringify(ordenes);
        return this.http.post(this.apiURL + '/GetDetalleInventarioOrdenes', param, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetProcesoTrabajo(idSucursal: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetProcesoTrabajo/' + idSucursal, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetPlanTrabajoOS(idOrdenServicio: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetPlanTrabajoOS/' + idOrdenServicio, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public GetDetalleInventarioSucursal(idOrdenServicio: number): Observable<any> {
        const headers = this.getHeaders();

        return this.http.get(this.apiURL + '/GetDetalleInventarioSucursal/' + idOrdenServicio, { headers })
            .map((response: any) => {
                this.data = response;
                return this.data;
            })
            .catch(this.handleError)
    }

    public RecibirAlmacen(plan: any) {
        const headers = this.getHeaders();
        const param = JSON.stringify(plan);
        return this.http.post(this.apiURL + '/UpdAlmacen', param, { headers })
            .map((resultado: any) => {
                return resultado;
            })
            .catch((error: any) => {
                return Observable.throw(new Error(error.status));
            });
    }

    private getBaseUrl() {
        return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
    }

    private getHeaders(): HttpHeaders {

        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return headers;
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/almacen-api.service.ts